import ContactProfileDto from '@/models/Contacts/ContactProfileDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';

export default class SpecOutBrowseContactsViewModel {
    contactProfiles: SelectableEntity<ContactProfileDto>[] = [];
    selectedContactId = '';
    selectedContactIds: string[] = [];
    selectedContact: ContactProfileDto = new ContactProfileDto();
}
